// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/* eslint-disable  */

import React, { useEffect, useState } from "react";
import getGlobalVarContext from "../context/getGlobalVarContext"
export default function GlobalVarProvider(props) {
  const { children } = props;
  const GlobalVarContext = getGlobalVarContext();
  const [globalVar, setGlobalVar] = useState({
    data: {},
    renderView: false,
    pubnub: "",
    personalChannel:[],
    groupList: [],
    subID: null,
    email: null,
    groupUserList:[],
    newPersonalsearchList: [],
    newGroupsearchList:[],
    userDetalis: null,
    page: true,
    isRightSideBarOpen: false,
  });
  return (
    <GlobalVarContext.Provider value={{ globalVar, setGlobalVar}}>
      {children}
    </GlobalVarContext.Provider>
  );
}
